import { render } from "./QRCodePopUp.vue?vue&type=template&id=62ba6d36&scoped=true&ts=true"
import script from "./QRCodePopUp.vue?vue&type=script&lang=ts"
export * from "./QRCodePopUp.vue?vue&type=script&lang=ts"

import "./QRCodePopUp.vue?vue&type=style&index=0&id=62ba6d36&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ba6d36"]])

export default __exports__